import { useQuery } from '@tanstack/react-query';
import { get } from '@truefit/http-utils';

import { isSignedIn, useAuth } from '@/features/scaffolding/components/AuthContext';

import { ConfigVersionSummary, configRegistryKeys } from './useConfigsQuery';

/** The history list. Newest first, payload-free — snapshots load on expand. */
export const useConfigVersionsQuery = (key: string | null, enabled = true) => {
  const { sessionState } = useAuth();
  const isReady = isSignedIn(sessionState);

  return useQuery({
    queryKey: configRegistryKeys.versions(key ?? ''),
    queryFn: async () => {
      const { data } = await get<ConfigVersionSummary[]>(
        `/v1.0/internals/configs/${encodeURIComponent(key as string)}/versions`,
      );
      return data;
    },
    enabled: isReady && !!key && enabled,
  });
};

export default useConfigVersionsQuery;
